import { MarketingCalendarCampaignsListController } from './marketing-calendar-campaigns-list.controller'

function marketingCalendarCampaignsList () {
  return {
    restrict: 'E',
    scope: {
      campaigns: '<',
      loading: '<',
      loadMoreCampaigns: '&',
      handleBackClick: '&'
    },
    templateUrl: '/workflow/directives/marketing-calendar-campaigns-list/marketing-calendar-campaigns-list.html?$$REVISION$$',
    controller: MarketingCalendarCampaignsListController
  }
}

export { marketingCalendarCampaignsList }
